<template>
  <div
    class="main-content"
    :class="{
      'main-content--left-sidebar-present': leftSidebar,
      'main-content--right-sidebar-present': rightSidebar
    }"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['left-sidebar', 'right-sidebar'],
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";

.main-content {
  width: 192rem;
  height: 98rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;

  .layout-switched & {
    top: 10rem;
  }

  &--right-sidebar-present {
    width: 159.5rem;
  }

  &--left-sidebar-present {
    width: 159.5rem;
  }

  .main--right-sidebar-present.main--left-sidebar-present {
    width: 159.5rem;
  }
}
</style>